import React from 'react';
import ArticleLink from '../models/ArticleLink';
import ArticleLinkCard, { ArticleLinkCardStyle } from '../components/ArticleLinkCard';
import ArticleLinkCardList from '../components/ArticleLinkCardList';
import { clearKeyValuePair, setKeyValuePair } from '@gik/ads/components/Ad';

interface GeneralResultsPageProps {
  pageName: string;
  articleLinks: ArticleLink[];
}

export default class GeneralResultsPage extends React.PureComponent<GeneralResultsPageProps> {
  componentDidMount() {
    setKeyValuePair(this.props.pageName);
  }

  componentWillUnmount() {
    clearKeyValuePair();
  }

  render() {
    const minCardsForFeatured = 5;
    const smallCardsOffset = 3;
    const chunkSize = 8;
    return (
      <div className="general-results-page">
        <div className="header">
          <h1>{this.props.pageName}</h1>
        </div>
        <div className="bs-padding-wrapper">
          <div className="bs-padding">
            {this.props.articleLinks.length < minCardsForFeatured && (
              <ArticleLinkCardList articleLinks={this.props.articleLinks} style={ArticleLinkCardStyle.small} showAds />
            )}
            {this.props.articleLinks.length >= minCardsForFeatured && (
              <ArticleLinkCard articleLink={this.props.articleLinks[0]} cardStyle={ArticleLinkCardStyle.featured} />
            )}
            {this.props.articleLinks.length >= minCardsForFeatured && (
              <ArticleLinkCardList
                articleLinks={this.props.articleLinks.slice(1, smallCardsOffset)}
                style={ArticleLinkCardStyle.featuredHalf}
              />
            )}
            {this.props.articleLinks.length >= minCardsForFeatured && (
              <ArticleLinkCardList
                articleLinks={this.props.articleLinks.slice(smallCardsOffset, smallCardsOffset + chunkSize)}
                style={ArticleLinkCardStyle.small}
                showAds
              />
            )}
            {this.props.articleLinks.length > smallCardsOffset + chunkSize && (
              <ArticleLinkCardList
                articleLinks={this.props.articleLinks.slice(smallCardsOffset + chunkSize)}
                style={ArticleLinkCardStyle.small}
                showAds
                showMoreButton
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
